module.exports = __webpack_public_path__ + "img/done.8e98efab.jpg";